import { getHowItWorksSteps } from '../constants/howItWorks';

export const getJsonLdHowTo = req => {
  const pageUrl = req.getPagePath('how-it-works');

  const steps = getHowItWorksSteps().map(item => {
    const itemListElement = [];

    item.bulletPoints.forEach(point => {
      itemListElement.push({
        '@type': 'HowToStep',
        name: req.trans(point.titleKey),
        text: req.trans(point.textKey)
      });
    });

    return {
      '@type': 'HowToStep',
      name: req.trans(item.titleKey),
      text: req.trans(item.descriptionKey),
      url: pageUrl,
      itemListElement
    };
  });

  return {
    '@context': 'https://schema.org',
    '@type': 'HowTo',
    name: req.trans('listing.how-to-book.section-main-title'),
    description: req.trans('how_it_works.alt.hero.title'),
    step: steps
  };
};
